import { useState as m, useRef as f, useMemo as x } from "react";
import { u as p } from "./index-BqI2IZQT.mjs";
function S(i, o) {
  const [a, s] = m({
    status: "not-executed",
    error: void 0,
    result: o
  }), e = f(void 0), n = f(void 0), d = p({
    execute(...u) {
      n.current = u;
      const t = i(...u);
      return e.current = t, s((r) => ({ ...r, status: "loading" })), t.then(
        (r) => {
          t === e.current && s((c) => ({ ...c, status: "success", error: void 0, result: r }));
        },
        // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
        (r) => {
          t === e.current && s((c) => ({ ...c, status: "error", error: r }));
        }
      ), t;
    },
    reset() {
      s({
        status: "not-executed",
        error: void 0,
        result: o
      }), e.current = void 0, n.current = void 0;
    }
  });
  return [
    a,
    x(
      () => ({
        reset() {
          d.current.reset();
        },
        execute: (...u) => d.current.execute(...u)
      }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    ),
    { promise: e.current, lastArgs: n.current }
  ];
}
export {
  S as u
};
//# sourceMappingURL=index-DH8aHDrB.mjs.map
